import React, { useState, useEffect } from 'react';
import { Popup } from 'devextreme-react';
import { LoadPanel } from 'devextreme-react/load-panel';
import axios from 'axios';
import notify from 'devextreme/ui/notify';

const ShowSignature = ({ visible, onClose, transactionHeaderRowId, accessToken }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [signatureDataUrl, setSignatureDataUrl] = useState(null);
    const [signatureInfo, setSignatureInfo] = useState(null);

    useEffect(() => {
        if (visible && transactionHeaderRowId) {
            fetchSignature();
        }
        if (!visible) {
            setSignatureDataUrl(null);
            setSignatureInfo(null);
        }
    }, [visible, transactionHeaderRowId]);

    const fetchSignature = async () => {
        setIsLoading(true);
        try {
            const apiUrl = `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/GetSignature`;
            const response = await axios.get(apiUrl, {
                params: { transactionHeaderRowId },
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.data && response.data.success) {
                setSignatureDataUrl(response.data.signature);
                setSignatureInfo({
                    lastUpdateDateTime: response.data.lastUpdateDateTime,
                    lastUpdateUserId: response.data.lastUpdateUserId
                });
            } else {
                notify({
                    message: response.data?.message || 'No signature found for this transaction.',
                    width: 300,
                }, 'warning', 3000);
                onClose();
            }
        } catch (error) {
            console.error('Error fetching signature:', error);
            notify({
                message: error.response?.data?.message || 'Error retrieving signature.',
                width: 300,
            }, 'error', 3000);
            onClose();
        } finally {
            setIsLoading(false);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        return d.toLocaleString();
    };

    return (
        <Popup
            visible={visible}
            onHiding={onClose}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title="Show Signature"
            width="620px"
            height="460px"
        >
            <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', height: '100%', position: 'relative' }}>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={{ of: '#showSignatureContainer' }}
                    visible={isLoading}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                    message="Loading signature..."
                />
                <div id="showSignatureContainer" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    {signatureDataUrl ? (
                        <>
                            <div style={{
                                flex: 1,
                                border: '1px solid #ccc',
                                backgroundColor: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden'
                            }}>
                                <img
                                    src={signatureDataUrl}
                                    alt="Signature"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>
                            {signatureInfo && (
                                <div style={{
                                    paddingTop: '10px',
                                    borderTop: '1px solid #eee',
                                    marginTop: '10px',
                                    fontSize: '13px',
                                    color: '#666',
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}>
                                    {signatureInfo.lastUpdateUserId && (
                                        <span>Signed by: <strong>{signatureInfo.lastUpdateUserId}</strong></span>
                                    )}
                                    {signatureInfo.lastUpdateDateTime && (
                                        <span>Date: <strong>{formatDate(signatureInfo.lastUpdateDateTime)}</strong></span>
                                    )}
                                </div>
                            )}
                        </>
                    ) : (
                        !isLoading && (
                            <div style={{
                                flex: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#999',
                                fontSize: '16px'
                            }}>
                                No signature available.
                            </div>
                        )
                    )}
                </div>
            </div>
        </Popup>
    );
};

export default ShowSignature;
